import { Button } from "@chakra-ui/react";

import EmptyState, { EmptyStateProps } from "@/common/components/EmptyState";
import { IcoFeature } from "@/common/components/Icons";
import { useSearchParam } from "@/common/hooks/useSearchParam";
import { useCompanyFlagsTableState } from "@/company/hooks/useCompanyTableStates";

type Props = EmptyStateProps & {
  isError?: boolean;
  onRetry?: () => void;
};

export const CompanyFlagsEmptyState = ({
  isLoading,
  isError,
  onRetry,
  ...rest
}: Props) => {
  const [featureFilter, setFeatureFilter] = useSearchParam("featureFilter");
  const { searchQuery, onSearchQueryChange } = useCompanyFlagsTableState();

  return (
    <EmptyState
      description={
        !isLoading &&
        (featureFilter || searchQuery) && (
          <Button
            color="dimmed"
            fontSize="sm"
            variant="link"
            onClick={() => {
              setFeatureFilter(null);
              onSearchQueryChange("");
            }}
          >
            Clear filters
          </Button>
        )
      }
      error="Failed to load company flags"
      flexGrow={1}
      icon={<IcoFeature boxSize="48px" />}
      isError={isError}
      isLoading={isLoading}
      pt="24"
      title="No flags to show"
      onRetry={onRetry}
      {...rest}
    />
  );
};
